<div class="grupo-classificacao-filter">
    <div class="grupo-classificacao-filter-quick">  
        <div class="grupo-classificacao-filter-quick-block grupo-classificacao-filter-quick-block-multiselect">
            <!-- Tipos de Classificações -->
            <div class="grupo-classificacao-filter-quick-block-options-multiselect-item">
                <sgt-tipo-classificacao-multiselect
                    [(idsTiposClassificacoes)]="filter.idsTiposClassificacoes"
                    (idsTiposClassificacoesChange)="onChangeTiposClassificacoes()"
                    [(nullOption)]="filter.tipoClassificacaoNull"
                    [showNullOption]="true"
                    defaultTitle="Tipos de Segmentos"
                    [disabled]="!isFilterInitialized">
                </sgt-tipo-classificacao-multiselect>
            </div>

            <!-- Classificações -->
            <div class="grupo-classificacao-filter-quick-block-options-multiselect-item">
                <sgt-classificacao-tipo-multiselect
                    [(idsClassificacoes)]="filter.idsClassificacoes"
                    (idsClassificacoesChange)="onChangeClassificacoes()"
                    [(nullOption)]="filter.classificacaoNull"
                    [showNullOption]="true"
                    defaultTitle="Segmentos"
                    [disabled]="!isFilterInitialized">
                </sgt-classificacao-tipo-multiselect>
            </div>                

            <!-- Situação -->
            <div class="grupo-classificacao-filter-quick-block-options-multiselect-item">
                <sgt-grupo-classificacao-situacao-multiselect
                    [(situacoes)]="filter.situacoes"
                    (situacoesChange)="onChangeSituacoes()"
                    defaultTitle="Situações"
                    [disabled]="!isFilterInitialized">
                </sgt-grupo-classificacao-situacao-multiselect>
            </div>

            <!-- Configurações -->
            <div class="grupo-classificacao-filter-quick-block-options-multiselect-item">
                <sgt-grupo-classificacao-config-multiselect
                    [(considerarClienteAnaliseMercado)]="filter.considerarClienteAnaliseMercado"
                    [(considerarMeta)]="filter.considerarMeta"
                    (configuracoesChange)="onChangeConfiguracoes()"
                    defaultTitle="Configurações"
                    [disabled]="!isFilterInitialized">
                </sgt-grupo-classificacao-config-multiselect>
            </div>            
        </div>


        <div class="grupo-classificacao-filter-quick-block grupo-classificacao-filter-quick-block-filter-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
        </div>        

        <div class="grupo-classificacao-filter-quick-block grupo-classificacao-filter-quick-block-options">
            <div class="grupo-classificacao-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
    
                    <!--
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                    -->
                </div>  
            </div>
        </div>
    </div>

    
    <div class="grupo-classificacao-filter-collapse" #filterCollapse></div>
</div>

